import React from "react";
import { Link } from "react-router-dom";
import AMAWidget from "./amawidget";

const HomeAMA = () => {
  return (
    <div>

      {/* Section header - full width */}
      <div className="flex flex-row items-center pb-6">
        <div className="flex-grow-0 font-sans text-slate-400 font-medium pr-4 md:text-xl text-lg">
          Curious?
        </div>
        <div className="flex-grow h-[1px] bg-slate-700"></div>
      </div>

      {/* Input + chips + link - centered */}
      <div className="flex flex-col items-center">
        <div className="w-full md:w-3/4">
          <div className="font-mono text-teal-300 md:text-xl text-lg pb-4">
            Ask me anything...
          </div>
          <AMAWidget />
          <div className="pt-4">
            <Link
              to="/projects/ask-me-anything"
              className="font-mono text-sm text-slate-500 hover:text-teal-300 transition-colors duration-200"
            >
              → How this works
            </Link>
          </div>
        </div>
      </div>

    </div>
  );
};

export default HomeAMA;